/**
 * @param SkeletonComponent
 */
const withSkeleton =
	(SkeletonComponent, defaultCount = 3) =>
	(WrappedComponent, itemPropName = 'item') => {
		return ({
			loading,
			items = [],
			skeletonCount,
			passIndex = true,
			...props
		}) => {
			const itemCount = skeletonCount || defaultCount;

			if (loading) {
				return (
					<>
						{Array.from({ length: itemCount }).map((_, index) => (
							<SkeletonComponent key={index} />
						))}
					</>
				);
			} else {
				return (
					<>
						{items.map((item, index) => (
							<WrappedComponent
								key={index}
								{...props}
								{...{ [itemPropName]: item }}
								{...(passIndex && {
									index,
									lastItem: index === items.length - 1,
								})}
							/>
						))}
					</>
				);
			}
		};
	};

export default withSkeleton;
